import axios, { AxiosResponse, AxiosRequestConfig, AxiosInstance } from 'axios';
import { makeApiError } from './api_error';
import { MessageBox } from 'element-ui';

const LOGIN_REQUIRED = 'LOGIN_REQUIRED';
declare const CSRF_TOKEN: string;

const alertLoginBox = () => {
  MessageBox.alert('点击重新登录', '用户状态获取失败', {
    confirmButtonText: '确定',
    callback: () => {
      // 保存当前页面URL，登录后可以跳转回来
      const currentPath = window.location.pathname + window.location.search + window.location.hash;
      window.location.href = `/login?redirect=${encodeURIComponent(currentPath)}`;
    }
  });
};

class HttpApi {
  rawApi: AxiosInstance;

  constructor(url: string) {
    this.rawApi = axios.create({
      baseURL: url
    });
    this.rawApi.interceptors.request.use(function(config: AxiosRequestConfig) {
      if (CSRF_TOKEN) {
        if (config.method == 'put' || config.method == 'post' || config.method == 'delete') {
          config.headers['CSRF-Token'] = CSRF_TOKEN;
        }
      }
      return config;
    });
    this.rawApi.interceptors.response.use(function(response: AxiosResponse<any>) {
      if (response.headers['content-type']?.startsWith('application/json')) {
        if (response.data.ok) {
          response.data = response.data.result;
        } else {
          if (response.data.error.code == LOGIN_REQUIRED) {
            //如果登录状态失败，提示并刷新页面
            alertLoginBox();
          }
          return Promise.reject(makeApiError(response.data.error));
        }
      }
      return response;
    });
  }

  getUri(config?: AxiosRequestConfig): string {
    return this.rawApi.getUri(config);
  }

  async request<T = any>(config: AxiosRequestConfig): Promise<T> {
    const response = await this.rawApi.request(config);
    return response.data;
  }

  async get<T = any>(url: string, config?: AxiosRequestConfig): Promise<T> {
    const response = await this.rawApi.get(url, config);
    return response.data;
  }

  async delete<T = any>(url: string, config?: AxiosRequestConfig): Promise<T> {
    const response = await this.rawApi.delete(url, config);
    return response.data;
  }

  async post<T = any>(url: string, data?: any, config?: AxiosRequestConfig): Promise<T> {
    const response = await this.rawApi.post(url, data, config);
    return response.data;
  }

  async put<T = any>(url: string, data?: any, config?: AxiosRequestConfig): Promise<T> {
    const response = await this.rawApi.put(url, data, config);
    return response.data;
  }
}

export const api = new HttpApi('/api');
export const apiSaml = new HttpApi('/saml2');
